import makeDataModelsSettings from "./dataModels";
import makeFeatureFlagsSettings from "./featuresFlags";
import makeRoutesSettings from "./routes";
import settings from "@/assets/settings/settings.json";

export default dependencies => {
    return {
        ...settings,
        ...makeDataModelsSettings(dependencies),
        ...makeFeatureFlagsSettings(dependencies),
        ...makeRoutesSettings(dependencies),
    };
};
